import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  container: {
    margin: "10px 0px 60px 0px",
  },
  text: {
    fontSize: "14px",
    margin: "0px 0px 12px 0px",
  },
}));
